'use client'

import { useEffect, useRef } from 'react'
import { AlertContainer } from 'ui'

import { useMagicLinksHandling } from '@/hooks/useMagicLinksHandling'
import { useScrollFix } from '@/hooks/useScrollFix'
import { useCart } from '@/store/cartStore'
import { useCustomer } from '@/store/customerStore'
import { usePreviousPath } from '@/store/previousPathStore'

/**
 * This component will setup client side functionality
 */
const SetupClientComponent = () => {
  useScrollFix()

  const cart = useCart()
  const customerRehydrated = useRef(false)

  useEffect(() => {
    usePreviousPath.persist.rehydrate()
    useCart.persist.rehydrate()
  }, [])

  useEffect(() => {
    // Rehydrate once. The ref guard stops Strict Mode's double-invoked effect
    // from firing a second, concurrent token refresh that can clobber the session.
    if (cart.isLoaded && !customerRehydrated.current) {
      customerRehydrated.current = true
      useCustomer.persist.rehydrate()
    }
  }, [cart.isLoaded])

  useMagicLinksHandling()

  return <AlertContainer position={cart.isOpen ? 'top-left' : 'top-right'} />
}

export default SetupClientComponent
